import { Distance } from "domain/entities/distance";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface DistancyState {
  distance: Distance | null;
  setDistance: (newParameter: Partial<Distance>) => void;
  resetDistance: () => void;
}

const initialDistancyState: Distance = {
  id: "",
  locationOrigin: "",
  locationDestination: "",
  distanceKm: 0,
  type: "",
  createdAt: new Date(),
  modifiedAt: new Date(),
  lastModifiedBy: "",
};

export const useDistancyCreateStore = create<DistancyState>()(
  devtools(
    (set) => ({
      distance: initialDistancyState,
      setDistance: (newParameter: Distance) =>
        set((state) => ({
          distance: { ...state.distance, ...newParameter } as Distance,
        })),
      resetDistance: () => set({ distance: initialDistancyState }),
    }),
    { name: "ParameterSelected" }
  )
);
